import { routeMapping } from "#localization/constants";
import { ROUTE_PATHS } from "../../../screens/route-paths";

export const chooseClassName = ({ authenticated, isMobile, pathname, isSticky }) => {
    let classNameHeader = "";
    let logoType = "standard";

    if (!authenticated && ["/home", "/"].includes(pathname)) {
        classNameHeader = isMobile ? "light" : "transparent";
        if (!isSticky && !isMobile) logoType = "light";
    }

    // if (!authenticated && ["/whiskeyvest"].includes(pathname)) {
    //     classNameHeader = isMobile ? "light" : "transparent";
    //     if (!isSticky && !isMobile) logoType = "light";
    // }

    if ([ROUTE_PATHS.aboutUs].includes(pathname)) {
        classNameHeader = "light";
    }

    if ([ROUTE_PATHS.home].includes(pathname) && isSticky) {
        classNameHeader = "darkBlue";
        logoType = "green";
    }

    if (pathname.includes(ROUTE_PATHS.howItWorks)) {
        logoType = "standard";
    }

    if (pathname.includes(ROUTE_PATHS.sustainability)) {
        classNameHeader = "blue";
        logoType = "green";
    }

    if (
        [
            ROUTE_PATHS.vinovest100Index,
            ROUTE_PATHS.whyWine,
            ROUTE_PATHS.wineFutures,
            ROUTE_PATHS.whiskeyInvestment,
            ROUTE_PATHS.reserveCask,
        ].includes(pathname)
    ) {
        classNameHeader = "darkBlue";
        logoType = "light";
    }

    return { classNameHeader, logoType };
};

// const makeConditionalString = `((\\/${Object.values(routeMapping).filter(Boolean).join("|")})\\/)?`;
const paths = ["/login", "/reset_password", "/signup", "/implicit/callback"];

export const hideForLogin = (pathname, authenticated = false) => {
    const hidePaths = authenticated ? paths.concat(["/"]) : paths;
    const unauthenticatedPaths = new RegExp(`^(${paths.join("|")})$`);
    const authenticatedPaths = /^\/$/;
    return unauthenticatedPaths.test(pathname) || (authenticatedPaths.test(pathname) && authenticated);
    // return new RegExp(`^(${hidePaths.join("|")})$`).test(pathname);
};

export const ACCOUNT_LINK = {
    to: "/account",
    label: "Account",
    exact: true,
    isActive: (_, location) => location.pathname === "/account",
};
